// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1o8_r","row":"styles_row__2Xgba"};